export default __webpack_public_path__ + "static/media/Register.d4c452e3.png";